'use client';

import { useTransCommon } from '@/@shared/hooks/useTranslations';
import { currentInfoUpdate } from '@/legacy/apis/repository/content';
import { addLayer } from '@/legacy/components/apps/ClientModalProvider';
import DiagonalViewportModal from '@/legacy/components/apps/DiagonalViewportModal';
import { clc } from '@/legacy/components/base/utils';
import ProfileImageV2 from '@/legacy/components/img/Profilev2';
import { KEBAB_KEY } from '@/legacy/components/modalContents/KebabModal';
import ProfileModal from '@/legacy/components/modalContents/ProfileModal';
import styles from '@/legacy/components/widget/Profile.module.scss';
import { LOGIN_PATHNAME } from '@/legacy/constants/pathname';
import useLocaleLink from '@/legacy/hooks/useLocaleLink';
import { useGetCurrentOwner } from '@/model/dexie/ownerDexie';
import { promiseNotNullCheck } from '@/utilities/stateTool';
import Link from 'next/link';
import { useEffect } from 'react';

interface Props {
	className?: string;
}

const ProfileBtn = ({ className }: Props) => {
	const user = useGetCurrentOwner();

	const locale = useLocaleLink();
	const t = useTransCommon('temp.modal');

	useEffect(() => {
		currentInfoUpdate();
	}, []);

	// usememo 대상일지도
	const modalOpen = (target: HTMLElement) => {
		addLayer(
			KEBAB_KEY,
			<DiagonalViewportModal align="right" axis="bottomLeft" offset={16} target={target}>
				<ProfileModal />
			</DiagonalViewportModal>,
			{
				escapeActive: true,
				freeze: false,
				outsideDismiss: true,
				style: {
					alignItems: 'flex-start',
					backgroundColor: 'transparent',
					justifyContent: 'flex-start',
				},
			}
		);
	};

	// const nextHref = user ? '/' + locale + '/user' : LOGIN_PATHNAME(locale)

	// 로딩 중 (undefined)
	if (user === undefined) {
		return (
			<div className={clc(styles.iconArea)} style={{ opacity: 0.5 }}>
				<ProfileImageV2 size={40} src={undefined} type="COMMON" />
			</div>
		);
	}

	// 로그인 안 한 상태 (PromiseNull)
	if (!promiseNotNullCheck(user)) {
		return (
			<Link className={clc(className)} href={LOGIN_PATHNAME(locale)} scroll={false}>
				{t('login')}
			</Link>
		);
	}

	// 로그인한 상태
	if (user && user.stepinId) {
		return (
			<button className={clc(styles.iconArea)} onClick={(e) => modalOpen(e.currentTarget)}>
				<ProfileImageV2 size={40} src={user.profileImageUrl} type={user.authority === 'USER' ? 'COMMON' : 'BUSINESS'} />
			</button>
		);
	}

	// 기타 (stepinId 없는 경우)
	return (
		<Link className={clc(className)} href={LOGIN_PATHNAME(locale)} scroll={false}>
			{t('login')}
		</Link>
	);
};

export default ProfileBtn;
